import React from 'react'
import { useSelector } from "react-redux";
import ProductCard from '../../Common/Product/ProductCard';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Heading from '../Heading';
import PrevArrow from '../PrevArrow';
import NextArrow from '../NextArrow';

const TodayDeal = () => {
  let products = useSelector((state) => state.products.products);
  const offerProducts = products.filter(i => {
    const availableStock = i?.availableStock || 0;
    return i.uploadType === "Offer" && availableStock > 0 && i.todayDeal
  })
  let settings = {
    arrows: true,
    dots: true,
    margin: 30,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [{

      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      }
    },
    ],
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  };
  return (
    <>
      <section id="to_days_area" className="ptb-100 slider_arrows_one">
        <div className="container">
          <Heading heading="Today's Deal" para="Don't miss out on our special offer! For today only,  This is your chance to grab the best deals at unbeatable prices. Hurry, the clock is ticking, and stocks are limited!" />
          <div className="row">
                  {offerProducts.map((data, index) => (
                    <div
                    className="col-lg-3 col-md-4 col-sm-6 col-12"
                    key={index}
                  >
                    <ProductCard data={data} />
                  </div>
                  ))}
                  </div>
           
        </div>
      </section>
    </>
  )
}

export default TodayDeal
